<template>
  <div>
      <div class="liveStop" ><a class="buttom" @click="backLivePage()">返回直播页</a></div>
  </div>
</template>

<script>
    export default {
        data(){
            return {

            }
        },
        methods:{
            backLivePage(){
                let ds_id = this.$route.query.ds_id || ''
                let channel_id = this.$route.query.channel_id || ''
                let link_mic_jump = this.$route.query.link_mic_jump || ''
                if (channel_id) {
                  location.href = "./?channel_id=" + channel_id + "&link_mic_jump=" + link_mic_jump  
                }else{
                  location.href = "./?ds_id=" + ds_id + "&link_mic_jump=" + link_mic_jump  
                }
            }
        }
    }
</script>

<style lang="less" scoped>
.liveStop {
    margin-top: 250px;
    text-align: center;
    .buttom {
        width: 200px;
        height: 40px;
        line-height: 40px;
        display: inline-block;
        text-align: center;
        background: #3844e8;
        font-size: 20px;
        color: white;
        border-radius: 5px;
    }
  }
</style>


// WEBPACK FOOTER //
// livestop.vue?6ab06ef2